import { Flags } from "src/consts/flags";

export const flagDefaults: Record<Flags, boolean | object | number> = {
    [Flags.MAINTENANCE_WINDOW]: false,

    // Passing 0 renders default text that you are likely eligible without APR shown
    [Flags.APR_REPRESENTATIVE]: 0,
};
